import { render, staticRenderFns } from "./MessageButtons.vue?vue&type=template&id=0b822c33&scoped=true&"
import script from "./MessageButtons.vue?vue&type=script&lang=js&"
export * from "./MessageButtons.vue?vue&type=script&lang=js&"
import style0 from "./MessageButtons.vue?vue&type=style&index=0&id=0b822c33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b822c33",
  null
  
)

export default component.exports